import React, { useEffect, useState } from 'react';
import App1 from './measurit/app1';
import BBAdmin from './BBAdmin/BBAdminRouting';
import HtmlApp from './HtmlApp';
import Measurit_v3 from './Measurit_v3.0/App_M_3.0';
import Consumer_app from './ConsumerApp/Consumer_app';
import Supplier from './Supplier/App';
import App from './Manufacturer/ManRouting';
import Visitor from './visitotApp/visitorRouting';
import './App.css';
import DeliveryPartner from './DeliveryPartner/App';

//import { requestPermission, handleForegroundNotifications } from './push-notifications';

const MainApp = () => {
  const [shouldRenderApp1, setShouldRenderApp1] = useState(false);
  const [shouldRenderBBAdmin, setShouldRenderBBAdmin] = useState(false);
  const [shouldRenderHtmlApp, setShouldRenderHtmlApp] = useState(false);
  const [shouldRendermeasurit, setShouldRendermeasurit] = useState(false);
  const [shouldRenderconsumerapp, setShouldRenderconsumerapp] = useState(false);
  const [shouldRenderSupplier, setShouldRenderSupplier] = useState(false);
  const [shouldRenderManufacturer, setShouldRenderManufacturer] = useState(false);
  const [shouldRenderVisitor, setShouldRenderVisitor] = useState(false);
  const [shouldRenderDeliveryPartner, setShouldRenderDeliveryPartner] = useState(false);

  useEffect(() => {
    const path = window.location.pathname;

      // Handle shared RFQ URL
  if (path.startsWith('/rfq/')) {
    const rfqId = path.split('/rfq/')[1];
     const params = new URLSearchParams(window.location.search);
    const customerId = params.get('customer_id');
    if (rfqId) {
       const targetUrl =
        `/consumer/account/rfqs` +
        `?rfq_id=${encodeURIComponent(rfqId)}` +
        (customerId
          ? `&customer_id=${encodeURIComponent(customerId)}`
          : '');

      window.location.replace(targetUrl);
      return;
    }
  }

    // Check for specific paths first to avoid conflicts
    if (path.startsWith('/measurit_v3.0')) {
      setShouldRendermeasurit(true);
    } else if (path.startsWith('/measurit')) {
      setShouldRenderApp1(true);
    } else if (path.startsWith('/admin')) {
      setShouldRenderBBAdmin(true);
    } else if (path.startsWith('/consumer')) {
      setShouldRenderconsumerapp(true);
    }else if (path.startsWith('/supplier')) {
      setShouldRenderSupplier(true);
    }else if (path.startsWith('/mfr')) {
      setShouldRenderManufacturer(true);
    }else if (path.startsWith('/visitor')) {
      setShouldRenderVisitor(true);
    }else if (path.startsWith('/delivery')) {
      setShouldRenderDeliveryPartner(true);
    }else if (path === '/') {
      setShouldRenderHtmlApp(true);
    }
  }, []); // Empty dependency array ensures this runs only once

  return (
    <>
      {shouldRenderApp1 && <App1 />}
      {shouldRenderBBAdmin && <BBAdmin />}
      {shouldRendermeasurit && <Measurit_v3 />}
      {shouldRenderconsumerapp && <Consumer_app />} 
      {shouldRenderSupplier && <Supplier />}
      {shouldRenderHtmlApp && <HtmlApp />}
      {shouldRenderManufacturer && <App />}
      {shouldRenderVisitor && <Visitor />}
      {shouldRenderDeliveryPartner && <DeliveryPartner />}
    </>
    
  );
};

export default MainApp;
